// extracted by mini-css-extract-plugin
module.exports = {"container":"StatItem_container__BwoNG","icon":"StatItem_icon__3QDJ1","label":"StatItem_label__3eLQ4","stat":"StatItem_stat__1_5Ik"};